import type { Command } from "../types.ts";

export const projects: Command = {
  name: "projects",
  aliases: ["work", "ls"],
  description: "Things I've built.",
  run(ctx) {
    const list = ctx.term.profile.projects;
    list.forEach((proj, i) => {
      const num = String(i + 1).padStart(2, "0");
      ctx.printHTML(
        `<span class="c-dim">${num}</span> <span class="c-accent2">${e(proj.name)}</span> ` +
          proj.tech.map((t) => `<span class="tech-tag">${e(t)}</span>`).join(" "),
      );
      ctx.printHTML(`   <span class="c-text">${e(proj.description)}</span>`);
      const links: string[] = [];
      if (proj.link) links.push(link(proj.link, "live"));
      if (proj.repo) links.push(link(proj.repo, "code"));
      if (links.length) ctx.printHTML(`   ${links.join("&nbsp;&nbsp;")}`);
      ctx.print("");
    });
    ctx.printHTML(`<span class="c-muted">reach out with <span class="c-accent">/social</span></span>`);
  },
};

function link(href: string, label: string): string {
  return `<a class="link" href="${e(href)}" target="_blank" rel="noopener noreferrer">↗ ${e(label)}</a>`;
}
function e(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
